import React from "react";
import styles from "./FooterCardSection.module.css";
import { useTranslation } from "react-i18next";

import FooterCard, { AccentColor } from "./FooterCard";
import AssetsPack from "../../util/AssetsPack.js";
import StylePack from "../../util/StylePack.js";
import { useNavigate } from "react-router-dom";

interface FooterCardSectionProps {
  isWalletCardVisible?: boolean;
}

const FooterCardSection: React.FC<FooterCardSectionProps> = ({
  isWalletCardVisible = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className={styles["start-container"]}>
      <div className={styles["top-card-container"]}>
        <FooterCard
          title={t("footer_section.main_card_title")}
          subtitle={t("footer_section.main_card_subtitle")}
          buttonText={t("footer_section.main_card_button_text")}
          cardBackgroundStyle={StylePack.BACKGROUND_FOOTER_GET_STARTED}
          isFullWidth
          onClick={() => navigate("/download")}
          isDisable
        />
      </div>
      {isWalletCardVisible && (
        <div className={styles["cards-container"]}>
          <FooterCard
            title={t("footer_section.deposit_funds_title")}
            subtitle={t("footer_section.deposit_funds_subtitle")}
            buttonText={t("footer_section.deposit_funds_button_text")}
            icon={AssetsPack.icons.OBLIQUE_DOWN_ARROW.default}
            accentColor={AccentColor.blue}
            cardBackgroundStyle={StylePack.BACKGROUND_FOOTER_DEPOSIT_STYLE}
            onClick={() => navigate("/sign_up")}
            isDisable
          />
          <FooterCard
            title={t("footer_section.withdraw_funds_title")}
            subtitle={t("footer_section.withdraw_funds_subtitle")}
            buttonText={t("footer_section.withdraw_funds_button_text")}
            icon={AssetsPack.icons.ICON_GO.default}
            accentColor={AccentColor.green}
            cardBackgroundStyle={StylePack.BACKGROUND_FOOTER_WITHDRAW_STYLE}
            onClick={() => navigate("/sign_up")}
            isDisable
          />
        </div>
      )}
    </div>
  );
};

export default FooterCardSection;
